<template>
    <div>
        <!-- Inline -->
        <div class="row q-mb-md">
            <!-- Filters hide/show button -->
            <div class="col-6">
                <div class="row" style="justify-content: flex-start">
                    <div>
                        <q-btn
                            @click="showFilters()"
                            :text-color="hideFilters ? 'grey-5' : 'white'"
                            class="neutral-btn ctrl-button btn-compact"
                            :class="{ primary: !hideFilters }"
                            icon="filter_list"
                            :icon-right="
                                hideFilters
                                    ? 'keyboard_arrow_up'
                                    : 'keyboard_arrow_down'
                            "
                        />
                    </div>
                    <!-- Searchfield -->
                    <div class="q-ml-md" style="flex-grow: 1">
                        <q-input
                            color="grey-5"
                            v-model="searchTerm"
                            @input="applyFilters"
                            :placeholder="
                                getString('module.planning.list.filter.label')
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- Filters block -->
        <transition name="fade">
            <div v-if="!hideFilters" class="table-block q-mb-md">
                <div class="row q-pa-md" style="justify-content: space-between">
                    <!-- Searchfield -->
                    <div class="col-6 q-pa-md">
                        <q-input
                            color="primary"
                            v-model="filters.course"
                            @input="applyFilters"
                            :float-label="getString('module.planning.details.course')"
                        />
                    </div>
                </div>
                <div class="row q-pa-md" style="justify-content: space-between">
                    <div class="q-pa-md" style="vertical-align: middle">
                        <q-btn
                            :disable="!activeFilters"
                            @click="resetFilters()"
                            class="capitalize ctrl-button"
                            :color="activeFilters ? 'primary' : 'grey-4'"
                            label="Reset"
                        />
                    </div>
                </div>
            </div>
        </transition>
        <table-overview
            :endpoint="'course'"
            :responseFormat="'courses'"
            :noDataFormat="'courses'"
            :columns="columns"
            customEvents
            @click="goToCoursePlanning"
            :permission="permission"
            :module="'planning'"
            :selectable="true"
        >
        </table-overview>
    </div>
</template>

<script>
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

export default {
  mixins: [
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      rowSelection: [],
      filters: {
        course: '',
        location: '',
      },
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      permission: 'planning',
      // Where data is fetched from
      endpoint: 'planning',
      // The object key from the response object
      responseData: {
        single: 'planning',
        multiple: 'plannings',
      },
      // Used for navigation on the front-end (matching the router)
      module: 'planning',
      searchTerm: '',
      selectable: true,
      isLoading: false,
      columns: [
        {
          name: '__slot:course-title',
          title: getString('title'),
          sortField: 'title',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:course-location',
          title: getString('block.type.button.location'),
          sortField: 'location',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s',
        },
        {
          name: 'type',
          title: 'Type',
          sortField: 'type',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s',
          callback: this.getType,
        },
        {
          name: 'sort',
          title: getString('module.course.details.sort'),
          sortField: 'sort',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s',
          callback: this.getSort,
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      }
    };
  },
  methods: {
    getString,

    goToCoursePlanning(data) {
      this.$router.push(`/planning/course/${data.row.id}`);
    },

    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },

  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
